import { memo, useState } from 'react';
import { SessionTimer } from 'common';
import { refreshSignInToken } from './useSilentSignIn';

function getTokenExpires() {
    return localStorage.getItem('token_expires') as string;
}

/** Mirrors the buyer/supplier portal `IdleTimerContainer`. */
export const PostSignupSessionTimer = memo(function PostSignupSessionTimer({ onLogout }: { onLogout(): void }) {
    const [tokenExpires, setTokenExpires] = useState(getTokenExpires());

    const expiresIn = new Date(tokenExpires).getTime() - Date.now();

    const handleRetrieveTokenExpiration = () => {
        setTokenExpires(getTokenExpires());
    };

    return (
        <SessionTimer
            expiresInMilliseconds={expiresIn}
            retrieveTokenExpiration={handleRetrieveTokenExpiration}
            refreshUserLogin={refreshSignInToken}
            logout={onLogout}
        />
    );
});
